/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Pro_8Inputs */



/**
* | output |
* | --- |
* | "Advanced subtitle export including SCC, MCC, and EBU STL" |
*
* @param {Signup_Feature_Pro_8Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_pro_8 = /** @type {((inputs?: Signup_Feature_Pro_8Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Pro_8Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Advanced subtitle export including SCC, MCC, and EBU STL")
	if (locale === "de") return /** @type {LocalizedString} */ ("Advanced subtitle export including SCC, MCC, and EBU STL")
	if (locale === "it") return /** @type {LocalizedString} */ ("Advanced subtitle export including SCC, MCC, and EBU STL")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Advanced subtitle export including SCC, MCC, and EBU STL")
	if (locale === "es") return /** @type {LocalizedString} */ ("Advanced subtitle export including SCC, MCC, and EBU STL")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Advanced subtitle export including SCC, MCC, and EBU STL")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Advanced subtitle export including SCC, MCC, and EBU STL")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Advanced subtitle export including SCC, MCC, and EBU STL")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Advanced subtitle export including SCC, MCC, and EBU STL")
	return /** @type {LocalizedString} */ ("Advanced subtitle export including SCC, MCC, and EBU STL")
});